<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center pb-2 mb-3 globalborder-btm-header px-3">
        <span class="col-auto">
          <h2 class="mb-0">BackLog Details</h2>
        </span>
        <span
          class="d-flex gap-2 customizefilter-btn align-items-center justify-content-between">
          <p-button
            label="Export Excel"
            variant="outlined"
            icon="pi pi-cloud-upload"
            severity="secondary"
            (click)="exportExcelFile()"
            class="fullwdth secondary-btn" />

          <span class="cross-border" (click)="onCloseModalEvent()"
            ><i class="pi pi-times"></i
          ></span>
        </span>
      </span>

      <div class="col-12">
        <p-table
          #dt
          stripedRows
          [rowHover]="true"
          [rows]="25"
          [showCurrentPageReport]="true"
          [scrollable]="true"
          scrollHeight="calc(100vh - 310px)"
          [size]="'small'"
          [resizableColumns]="true"
          responsiveLayout="scroll"
          [value]="backlogDetailsLists"
          [rowHover]="true"
          [rows]="20"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 1000]"
          [paginator]="backlogDetailsLists.length >= 20 ? true : false"
          styleClass="table-listing p-datatable-customers p-head-pad">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th style="width: 6rem" pSortableColumn="SalesID">
                Sale order
                <p-sortIcon field="SalesID"></p-sortIcon>
                <p-columnFilter type="text" field="SalesID" display="menu">
                </p-columnFilter>
              </th>
              <th pSortableColumn="CustomerName">
                Name
                <p-sortIcon field="CustomerName"></p-sortIcon>
                <p-columnFilter type="text" field="CustomerName" display="menu">
                </p-columnFilter>
              </th>
              <th pSortableColumn="CustomerAccount">
                Client account
                <p-sortIcon field="CustomerAccount"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="CustomerAccount"
                  display="menu">
                </p-columnFilter>
              </th>
              <th pSortableColumn="JobName">
                Job name
                <p-sortIcon field="JobName"></p-sortIcon>
                <p-columnFilter type="text" field="JobName" display="menu">
                </p-columnFilter>
              </th>
              <th pSortableColumn="OrderDate">
                Order date
                <p-sortIcon field="OrderDate"></p-sortIcon>
                <p-columnFilter type="text" field="OrderDate" display="menu">
                </p-columnFilter>
              </th>
              <th pSortableColumn="InHandDate">
                In-hand date
                <p-sortIcon field="InHandDate"></p-sortIcon>
                <p-columnFilter type="text" field="InHandDate" display="menu">
                </p-columnFilter>
              </th>
              <th pSortableColumn="TotalOpenSell">
                Total open sell
                <p-sortIcon field="TotalOpenSell"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="TotalOpenSell"
                  display="menu">
                </p-columnFilter>
              </th>
              <th pSortableColumn="TotalOpenCost">
                Total open cost
                <p-sortIcon field="TotalOpenCost"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="TotalOpenCost"
                  display="menu">
                </p-columnFilter>
              </th>
              <th pSortableColumn="OpenEstimatedGP">
                Open estimated GP
                <p-sortIcon field="OpenEstimatedGP"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="OpenEstimatedGP"
                  display="menu">
                </p-columnFilter>
              </th>
              <th pSortableColumn="OpenEstimatedGPPercentage">
                Open estimated GP percentage
                <p-sortIcon field="OpenEstimatedGPPercentage"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="OpenEstimatedGPPercentage"
                  display="menu">
                </p-columnFilter>
              </th>
              <th pSortableColumn="BCCommissionPercentage">
                BC commission percentage
                <p-sortIcon field="BCCommissionPercentage"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="BCCommissionPercentage"
                  display="menu">
                </p-columnFilter>
              </th>
              <th pSortableColumn="EstimatedBCCommission">
                Estimated BC commission
                <p-sortIcon field="EstimatedBCCommission"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="EstimatedBCCommission"
                  display="menu">
                </p-columnFilter>
              </th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-backlogDetailsList
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="backlogDetailsList"
              [pSelectableRowIndex]="rowIndex">
              <td>
                <a
                  class="link"
                  (click)="redirectToSummary(backlogDetailsList.SalesID)">
                  {{ backlogDetailsList.SalesID }}</a
                >
              </td>
              <td>
                <a
                  class="link"
                  (click)="
                    redirectToClientSummary(backlogDetailsList.CustomerAccount)
                  ">
                  {{ backlogDetailsList.CustomerName }}</a
                >
              </td>
              <td>
                <a
                  class="link"
                  (click)="
                    redirectToClientSummary(backlogDetailsList.CustomerAccount)
                  ">
                  {{ backlogDetailsList.CustomerAccount }}</a
                >
              </td>
              <td>{{ backlogDetailsList.JobName }}</td>
              <td>
                <span *ngIf="backlogDetailsList.OrderDate | hidedynamicsdate">
                  {{ backlogDetailsList.OrderDate | date: "MM-dd-yyyy" }}
                </span>
              </td>
              <td>
                <span *ngIf="backlogDetailsList.InHandDate | hidedynamicsdate">
                  {{ backlogDetailsList.InHandDate | date: "MM-dd-yyyy" }}
                </span>
              </td>
              <td class="align-right">
                {{ backlogDetailsList.TotalOpenSell | number: "1.2-2" }}
              </td>
              <td class="align-right">
                {{ backlogDetailsList.TotalOpenCost | number: "1.2-2" }}
              </td>
              <td class="align-right">
                {{ backlogDetailsList.OpenEstimatedGP | number: "1.2-2" }}
              </td>
              <td class="align-right">
                {{
                  backlogDetailsList.OpenEstimatedGPPercentage | number: "1.2-2"
                }}
              </td>
              <td class="align-right">
                {{
                  backlogDetailsList.BCCommissionPercentage | number: "1.2-2"
                }}
              </td>
              <td class="align-right">
                {{ backlogDetailsList.EstimatedBCCommission | number: "1.2-2" }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No backlog details found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>

<jni-modal-stacker
  *ngIf="clientDisplayModal"
  [displayModal]="clientDisplayModal"
  (closeEvent)="closeModal()">
  <h1 class="panelHeading">Client Summary</h1>
  <div class="panelBody">
    <jni-client-details
      [clientIdFromModal]="customerId"
      (closeModalOnRedirectionEvent)="closeModalOnRedirection()"
      (scrollHiddenStatus)="addScollHiddenClass()"
      [isModal]="true"
      (closeEvent)="closeModal()">
    </jni-client-details>
  </div>
</jni-modal-stacker>
